// This file is generated by pnpm icons:generate. Do not edit.

import {createSinglePathSVG} from './TEMPLATE'
import {TinyChevronBottom_Stroke2_Corner0_Rounded as CanonicalTinyChevronBottom_Stroke2_Corner0_Rounded} from './TinyChevronBottom'

export const ChevronBottom_Stroke2_Corner0_Rounded = createSinglePathSVG({
  path: 'm20.03 9.53-7.5 7.5a.75.75 0 0 1-1.06 0l-7.5-7.5a.75.75 0 0 1 1.06-1.06L12 15.44l6.97-6.97a.75.75 0 0 1 1.06 1.06Z',
  viewBox: '0 0 24 24',
  glyph: 'ChevronBottom_Stroke2_Corner0_Rounded',
})

export const ChevronLeft_Stroke2_Corner0_Rounded = createSinglePathSVG({
  path: 'M15.53 18.97a.75.75 0 0 1-1.06 1.06l-7.5-7.5a.75.75 0 0 1 0-1.06l7.5-7.5a.75.75 0 0 1 1.06 1.06L8.56 12Z',
  viewBox: '0 0 24 24',
  glyph: 'ChevronLeft_Stroke2_Corner0_Rounded',
})

export const ChevronRight_Stroke2_Corner0_Rounded = createSinglePathSVG({
  path: 'm17.03 12.53-7.5 7.5a.75.75 0 0 1-1.06-1.06L15.44 12 8.47 5.03a.75.75 0 0 1 1.06-1.06l7.5 7.5a.75.75 0 0 1 0 1.06Z',
  viewBox: '0 0 24 24',
  glyph: 'ChevronRight_Stroke2_Corner0_Rounded',
})

export const ChevronTop_Stroke2_Corner0_Rounded = createSinglePathSVG({
  path: 'M20.03 15.53a.75.75 0 0 1-1.06 0L12 8.56l-6.97 6.97a.75.75 0 0 1-1.06-1.06l7.5-7.5a.75.75 0 0 1 1.06 0l7.5 7.5a.75.75 0 0 1 0 1.06Z',
  viewBox: '0 0 24 24',
  glyph: 'ChevronTop_Stroke2_Corner0_Rounded',
})

export const ChevronTopBottom_Stroke2_Corner0_Rounded = createSinglePathSVG({
  path: 'M17.03 15.97a.75.75 0 0 1 0 1.06l-4.5 4.5a.75.75 0 0 1-1.06 0l-4.5-4.5a.75.75 0 0 1 1.06-1.06L12 19.94l3.97-3.97a.75.75 0 0 1 1.06 0Zm-9-7.94L12 4.06l3.97 3.97a.75.75 0 0 0 1.06-1.06l-4.5-4.5a.75.75 0 0 0-1.06 0l-4.5 4.5a.75.75 0 0 0 1.06 1.06Z',
  viewBox: '0 0 24 24',
  glyph: 'ChevronTopBottom_Stroke2_Corner0_Rounded',
})

/** @deprecated Import TinyChevronBottom_Stroke2_Corner0_Rounded from `#/components/icons/TinyChevronBottom` instead. */
export const TinyChevronBottom_Stroke2_Corner0_Rounded =
  CanonicalTinyChevronBottom_Stroke2_Corner0_Rounded
